import { Form } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledForm = styled(Form)``
